import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Drawer,
  IconButton,
  Divider,
  Typography,
  Chip,
  Avatar,
  Badge,
} from '@mui/material';
import {
  FaChartLine,
  FaUserClock,
  FaBed,
 
  FaFileInvoiceDollar,
 
  FaCalendarCheck,
 
  FaUsers,

  FaCog,
  FaSignOutAlt,
} from 'react-icons/fa';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import logo from '../../assets/images/logo.png';

function ReceptionistSidebar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // Get user data from localStorage - similar to HotelSidebar
  const getUserInfo = () => {
    try {
      const storedProfile = JSON.parse(localStorage.getItem('userProfile')) || {};
      console.log('Retrieved user profile:', storedProfile);
      
      return {
        name: storedProfile.full_name,
       
        designation: storedProfile.designation || storedProfile.position || 'F & B Staff',
        hotel: storedProfile.hotel_name || storedProfile.hotelcode || 'Hotel Management',
        department: storedProfile.department || 'Bar/Restaurant',
        avatar: storedProfile.avatar || "/static/images/avatar/1.jpg",
        hotelCode: storedProfile.hotelcode || storedProfile.hotel_code || 'HOTEL_001'
      };
    } catch (error) {
      console.error('Error retrieving user info:', error);
      return {
        name: 'Restaurant & Bar Staff',
        role: 'Restaurant/Bar',
        designation: 'F & B Staff',
        hotel: 'Hotel Management',
        department: 'Restaurant/Bar',
        avatar: "/static/images/avatar/1.jpg",
        hotelCode: 'HOTEL_001'
      };
    }
  };

const HOTEL_NAME = process.env.REACT_APP_HOTEL_NAME;
const SERVICE_PROVIDERS=process.env.REACT_APP_VENDOR_SERVICE_PROVIDERS;

  const userInfo = getUserInfo();

  const menuItems = [
    { 
      text: 'F & B Dashboard', 
      icon: <FaChartLine />, 
      link: '/hotel/fb/dashboard',
      badge: null
    },
    { 
      text: 'Orders', 
      icon: <FaUsers />, 
      link: '/hotel/fb/management',
      badge: null
    },

   
    { 
      text: 'My Account/Report', 
      icon: <FaUsers />, 
      link: '/hotel/fb/FBSalesReport',
      badge: null
    },
   
   { 
      text: 'Leave Calendar', 
      icon: <FaUsers />, 
      link: '/hotel/HR/LeaveCalendarFB',
      badge: null
    },
    
  ];

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const handleMenuItemClick = () => setDrawerOpen(false);

  const renderMenuItems = () => (
    <List sx={{ px: 2, py: 1 }}>
      {menuItems.map((item) => {
        const isSelected = location.pathname === item.link;
        return (
          <ListItem
            key={item.text}
            button
            component={Link}
            to={item.link}
            onClick={handleMenuItemClick}
            sx={{
              background: isSelected 
                ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.95) 0%, rgba(37, 99, 235, 0.95) 100%)'
                : 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)',
              backdropFilter: 'blur(20px)',
              borderRadius: '16px',
              paddingY: 1.5,
              paddingX: 2,
              marginY: 0.5,
              color: isSelected ? '#FFFFFF' : '#E8F4FD',
              position: 'relative',
              overflow: 'hidden',
              border: isSelected 
                ? '1px solid rgba(59, 130, 246, 0.5)'
                : '1px solid rgba(255, 255, 255, 0.1)',
              boxShadow: isSelected 
                ? '0 8px 32px rgba(37, 99, 235, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
                : '0 4px 20px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
              '&::before': isSelected ? {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                height: '100%',
                width: '4px',
                background: 'linear-gradient(180deg, #60A5FA 0%, #3B82F6 100%)',
                borderRadius: '0 4px 4px 0'
              } : {},
              '&:hover': {
                background: isSelected 
                  ? 'linear-gradient(135deg, rgba(59, 130, 246, 1) 0%, rgba(37, 99, 235, 1) 100%)'
                  : 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
                transform: 'translateX(4px) scale(1.02)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                border: isSelected 
                  ? '1px solid rgba(59, 130, 246, 0.7)'
                  : '1px solid rgba(255, 255, 255, 0.15)',
                boxShadow: isSelected
                  ? '0 12px 40px rgba(37, 99, 235, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.3)'
                  : '0 8px 25px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            <Box 
              sx={{ 
                marginRight: 2, 
                fontSize: '1.3rem',
                opacity: isSelected ? 1 : 0.8,
                color: isSelected ? '#FFFFFF' : '#93C5FD',
                filter: isSelected ? 'brightness(1.2) drop-shadow(0 2px 4px rgba(255,255,255,0.3))' : 'none',
                transition: 'all 0.3s ease',
              }}
            >
              {item.icon}
            </Box>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                fontSize: '0.95rem',
                fontWeight: isSelected ? 700 : 600,
                letterSpacing: '0.3px',
                color: isSelected ? '#FFFFFF' : '#F1F5F9',
                textShadow: isSelected ? '0 1px 2px rgba(0, 0, 0, 0.2)' : 'none',
              }}
            />
            {item.badge && (
              <Chip
                label={item.badge}
                size="small"
                color={item.badgeColor || 'primary'}
                sx={{
                  height: 24,
                  fontSize: '0.75rem',
                  minWidth: 24,
                  fontWeight: 700,
                  background: isSelected 
                    ? 'rgba(255, 255, 255, 0.25)'
                    : `linear-gradient(135deg, ${getBadgeColor(item.badgeColor)} 0%, ${getBadgeDarkColor(item.badgeColor)} 100%)`,
                  color: isSelected ? '#FFFFFF' : '#FFFFFF',
                  border: isSelected ? '1px solid rgba(255, 255, 255, 0.4)' : 'none',
                  boxShadow: isSelected ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.2)',
                  backdropFilter: 'blur(10px)',
                }}
              />
            )}
          </ListItem>
        );
      })}
    </List>
  );

  const getBadgeColor = (color) => {
    switch(color) {
      case 'success': return '#10B981';
      case 'warning': return '#F59E0B';
      case 'secondary': return '#8B5CF6';
      default: return '#3B82F6';
    }
  };

  const getBadgeDarkColor = (color) => {
    switch(color) {
      case 'success': return '#059669';
      case 'warning': return '#D97706';
      case 'secondary': return '#7C3AED';
      default: return '#2563EB';
    }
  };

  const sidebarContent = (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent 0%, rgba(59, 130, 246, 0.5) 50%, transparent 100%)',
        }
      }}
    >
      {/* Header with user info */}
      <Box sx={{ p: 3, pb: 2, position: 'relative' }}>
        {/* Glossy overlay */}
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '120px',
          background: 'linear-gradient(180deg, rgba(59, 130, 246, 0.1) 0%, transparent 100%)',
          pointerEvents: 'none',
        }}/>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, position: 'relative' }}>
          <Box sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              inset: -2,
              background: 'linear-gradient(135deg, #3B82F6, #8B5CF6, #EC4899)',
              borderRadius: '14px',
              zIndex: 0,
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(135deg, #1E293B, #334155)',
              borderRadius: '12px',
              zIndex: 1,
            }
          }}>
            <img src={logo} alt="Hotel Logo" style={{ 
              width: 44, 
              height: 44, 
              borderRadius: '12px',
              position: 'relative',
              zIndex: 2,
              border: '2px solid rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            }} />
          </Box>
          <Box sx={{ ml: 2, position: 'relative' }}>
            <Typography variant="h6" sx={{ 
              fontSize: '1.3rem', 
              fontWeight: 'bold', 
              color: '#FFFFFF',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
              background: 'linear-gradient(135deg, #FFFFFF 0%, #93C5FD 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>
              e-Neurons
            </Typography>
            <Typography variant="caption" sx={{ 
              color: '#CBD5E1',
              fontWeight: 600,
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
            }}>
             Service Providers: {SERVICE_PROVIDERS}
            </Typography>
          </Box>
        </Box>
        
        {/* User profile */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
          backdropFilter: 'blur(20px)',
          p: 2, 
          borderRadius: 3, 
          mb: 2,
          border: '1px solid rgba(255, 255, 255, 0.15)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '1px',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
          }
        }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            variant="dot"
            color="success"
            sx={{
              '& .MuiBadge-dot': {
                backgroundColor: '#10B981',
                boxShadow: '0 0 0 2px #1E293B',
              }
            }}
          >
            <Box sx={{
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: -2,
                background: 'linear-gradient(135deg, #3B82F6, #10B981)',
                borderRadius: '50%',
                zIndex: 0,
              }
            }}>
              <Avatar sx={{ 
                width: 48, 
                height: 48, 
                mr: 1.5,
                border: '2px solid #1E293B',
                backgroundColor: '#3B82F6',
                position: 'relative',
                zIndex: 1,
                boxShadow: '0 4px 20px rgba(59, 130, 246, 0.4)',
              }} src={userInfo.avatar}>
                {userInfo.name.charAt(0)}
              </Avatar>
            </Box>
          </Badge>
          <Box sx={{ flex: 1, ml: 1.5 }}>
            <Typography variant="subtitle2" sx={{ 
              fontWeight: 700, 
              color: '#FFFFFF',
              fontSize: '1rem',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
            }}>
              {userInfo.name}
            </Typography>
            <Typography variant="caption" sx={{ 
              color: '#93C5FD',
              fontWeight: 600,
              background: 'linear-gradient(135deg, #93C5FD, #60A5FA)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>
              {userInfo.role}
            </Typography>
            <Typography variant="caption" sx={{ 
              display: 'block',
              color: '#CBD5E1',
              fontWeight: 500,
              fontSize: '0.75rem',
            }}>
              {userInfo.designation}
            </Typography>
            <Typography variant="caption" sx={{ 
              display: 'block',
              color: '#94A3B8',
              fontWeight: 400,
              fontSize: '0.7rem',
            }}>
              Code: {userInfo.hotelCode}
            </Typography>
          </Box>
          <IconButton sx={{ 
            color: 'white',
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(37, 99, 235, 0.3) 100%)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%)',
              transform: 'scale(1.1)',
              boxShadow: '0 6px 20px rgba(37, 99, 235, 0.4)',
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }} size="small">
            <NotificationsIcon />
          </IconButton>
        </Box>

        {/* Quick Stats */}
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
          <Box sx={{ 
            textAlign: 'center', 
            p: 1.5, 
            backgroundColor: 'rgba(16, 185, 129, 0.15)', 
            borderRadius: 2,
            border: '1px solid rgba(16, 185, 129, 0.3)',
            backdropFilter: 'blur(10px)'
          }}>
            <Typography variant="caption" sx={{ color: '#A7F3D0', fontWeight: 600, fontSize: '0.7rem' }}>
              Hotel Code
            </Typography>
            <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem' }}>
              {userInfo.hotelCode}
            </Typography>
          </Box>
          <Box sx={{ 
            textAlign: 'center', 
            p: 1.5, 
            backgroundColor: 'rgba(59, 130, 246, 0.15)', 
            borderRadius: 2,
            border: '1px solid rgba(59, 130, 246, 0.3)',
            backdropFilter: 'blur(10px)'
          }}>
            <Typography variant="caption" sx={{ color: '#93C5FD', fontWeight: 600, fontSize: '0.7rem' }}>
              Department
            </Typography>
            <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.8rem' }}>
              {userInfo.department}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ 
        borderColor: 'rgba(255, 255, 255, 0.1)', 
        mx: 3, 
        my: 1,
        background: 'linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent)',
        height: '1px',
        border: 'none',
      }} />
      
      {/* Navigation */}
      <Box sx={{ flex: 1, overflowY: 'auto', py: 1 }}>
        {renderMenuItems()}
      </Box>

      {/* Footer */}
      <Box sx={{ p: 3, pt: 2, position: 'relative' }}>
        <Box sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '80px',
          background: 'linear-gradient(0deg, rgba(59, 130, 246, 0.1) 0%, transparent 100%)',
          pointerEvents: 'none',
        }}/>
        <Chip 
          label={HOTEL_NAME}
          size="small"
          sx={{ 
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(37, 99, 235, 0.2) 100%)',
            color: '#93C5FD',
            fontWeight: 700,
            fontSize: '0.8rem',
            mb: 1.5,
            border: '1px solid rgba(59, 130, 246, 0.3)',
            height: 28,
            backdropFilter: 'blur(10px)',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Box>
            <Typography variant="caption" sx={{ 
              display: 'block', 
              color: '#94A3B8',
              fontWeight: 500,
              fontSize: '0.75rem',
            }}>
              {userInfo.designation} Portal
            </Typography>
            <Typography variant="caption" sx={{ 
              display: 'block', 
              mt: 0.5, 
              color: '#64748B', 
              fontSize: '0.7rem',
              fontWeight: 400
            }}>
              Powered by e-neurons
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton sx={{ 
              color: '#94A3B8',
              fontSize: '0.9rem',
              '&:hover': {
                color: '#3B82F6',
                transform: 'scale(1.1)',
              },
              transition: 'all 0.2s ease',
            }} size="small">
              <FaCog />
            </IconButton>
            <IconButton sx={{ 
              color: '#94A3B8',
              fontSize: '0.9rem',
              '&:hover': {
                color: '#EF4444',
                transform: 'scale(1.1)',
              },
              transition: 'all 0.2s ease',
            }} size="small">
              <FaSignOutAlt />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      {/* Mobile menu button */}
      <Box
        sx={{
          position: 'fixed',
          top: 20,
          left: 20,
          zIndex: 1301,
          display: { xs: 'block', md: 'none' },
        }}
      >
        <IconButton 
          onClick={toggleDrawer}
          sx={{
            background: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 8px 32px rgba(37, 99, 235, 0.4)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            '&:hover': {
              background: 'linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)',
              transform: 'scale(1.1)',
              boxShadow: '0 12px 40px rgba(37, 99, 235, 0.6)',
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <MenuIcon sx={{ color: 'white', fontSize: '1.5rem' }} />
        </IconButton>
      </Box>

      {/* Drawer for mobile */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: 320,
            background: 'transparent',
            border: 'none',
            boxShadow: '16px 0 40px rgba(0, 0, 0, 0.3)',
          },
        }}
      >
        {sidebarContent}
      </Drawer>

      {/* Sidebar for desktop */}
      <Box
        sx={{
          width: 320,
          flexShrink: 0,
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          height: '100vh',
          position: 'sticky',
          top: 0,
          overflow: 'hidden',
          boxShadow: '16px 0 40px rgba(0, 0, 0, 0.3)',
        }}
      >
        {sidebarContent}
      </Box>
    </>
  );
}

export default ReceptionistSidebar;